import { useState } from 'react'

import { Grid } from '@material-ui/core'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import PictureCard from 'Components/UI/Atoms/PictureCard'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import { interfaces } from 'service/interfaces'

import DeletePhoto from './Delete'
import Upload from './Upload'

const File = (props) => {
  const { formEdit, dataVeh, setInitValues, setFormEdit, setHasChanged } = props

  const [change, setChange] = useState([])
  const [dataActions, setDataActions] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  function handleOpenUpload() {
    setDataActions({
      openUpload: true,
      id: dataVeh.vehicle.id,
    })
  }
  function handleChange(e) {
    e.preventDefault()
    let prevData = [...change]
    let files = e.target.files
    for (let i = 0; i < files.length; i++) {
      prevData[i] = files[i]
    }
    setChange(prevData)
  }

  function handleOpenDelete(index) {
    setDataActions({
      openUpload: false,
      openRemove: true,
      index: index,
    })
  }

  function handleCloseActions() {
    setChange([])
    setDataActions({
      openUpload: false,
      openRemove: false,
      id: null,
    })
  }

  function handleAdd(arr) {
    const newUrls = Array.isArray(arr) ? arr : [arr]

    setHasChanged(true)

    setFormEdit((prev) => ({
      ...prev,
      fotos: [...(prev.fotos || []), ...newUrls],
    }))

    setInitValues((prev) => ({
      ...prev,
      products: prev.products.map((prod) => {
        if (prod.id === formEdit.id) {
          return {
            ...prod,
            items: prod.items.map((item, i) =>
              i === props.itemIndex ? { ...item, fotos: [...(item.fotos || []), ...newUrls] } : item
            ),
          }
        }
        return prod
      }),
    }))
  }

  function handleDeleteContext(index) {
    setHasChanged(true)

    setFormEdit((prev) => ({
      ...prev,
      fotos: prev.fotos.filter((_, i) => i !== index),
    }))

    setInitValues((prev) => ({
      ...prev,
      products: prev.products.map((prod) => {
        if (prod.id === formEdit.id) {
          return {
            ...prod,
            items: prod.items.map((item, i) =>
              i === props.itemIndex
                ? { ...item, fotos: item.fotos.filter((_, j) => j !== index) }
                : item
            ),
          }
        }
        return prod
      }),
    }))
  }

  async function handleSubmitDelete(item) {
    setIsLoading(true)
    let index = formEdit.fotos?.indexOf(item)
    const body = formEdit.stock_id
      ? { stock_id: formEdit.stock_id, index: index + 1, url: item }
      : { url: item }
    await interfaces.plantStation
      .deletePhoto(body)
      .then((res) => {
        createDismissableSnackbar(res.data, { variant: 'success' })
        handleDeleteContext(index)
        handleCloseActions()
        setIsLoading(false)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
        handleCloseActions()
        setIsLoading(false)
      })
  }

  async function handleSubmitUpload(value) {
    setIsLoading(true)
    await interfaces.plantStation
      .uploadPhoto(formEdit.empresa, formEdit.id, value, formEdit.fotos?.length + 1)
      .then((res) => {
        setIsLoading(false)
        createDismissableSnackbar(res.data.data.msg, { variant: 'success' })
        handleAdd(res.data.data.url)
        handleCloseActions()
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
        handleCloseActions()
        setIsLoading(false)
      })
  }

  const removeDateFromUrl = (url) => {
    if (!url) return url
    return url.replace(/\/\d{2}-\d{2}-\d{4}\.webp$/, '.webp')
  }

  const swipes = formEdit.fotos?.map((item, index) => ({
    id: index,
    img: removeDateFromUrl(item),
  }))

  return (
    <div>
      <Grid container spacing={3} justify="center">
        {formEdit.fotos?.map((item, index) => (
          <Grid item xs={6} xl={6} sm={6} md={6}>
            <PictureCard
              img={removeDateFromUrl(item)}
              edit={true}
              txt={`Adicional ${index + 1}`}
              title={`Adicional ${index + 1}`}
              index={index + 1}
              swipes={swipes}
              // editDelete={edit}
              handleDelete={() => handleOpenDelete(item)}
            />
          </Grid>
        ))}
        <Grid item xs={12} xl={12} sm={12} md={12} container justifyContent="center">
          <CustomButton
            onClick={() => handleOpenUpload()}
            text="Agregar fotografías"
            style={{ margin: '10px 0px' }}
            size="small"
          />
        </Grid>
      </Grid>

      <DeletePhoto
        open={dataActions.openRemove}
        handleClose={handleCloseActions}
        onSubmit={() => handleSubmitDelete(dataActions.index)}
        loading={isLoading}
      />

      <Upload
        open={dataActions.openUpload}
        handleClose={handleCloseActions}
        onSubmit={handleSubmitUpload}
        handleChange={handleChange}
        change={change}
        loading={isLoading}
      />
    </div>
  )
}
export default File
